import { PEV } from "../../../../../common/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as service from "./service";

export const generateUserAccessHistoryTableId = (userId) => "userAccessHistoryTable-" + userId;

const initialState = {
  userAccessHistories: {},
};

const getUserAccessHistory = createAsyncThunk("userAccessHistory/fetch", async (param) => {
  return await service.fetchUserAccessHistory(param.userId);
});

const UserApplicationSlice = createSlice({
  name: "userAccessHistory",
  initialState,
  reducers: {},
  extraReducers: {
    [getUserAccessHistory.pending.type]: (state, action) => {
      let userId = action.meta.arg.userId;
      state.userAccessHistories[userId] = PEV(
        { ...state.userAccessHistories },
        "Fetching userAccessHistory"
      );
    },
    [getUserAccessHistory.fulfilled.type]: (state, action) => {
      let userId = action.meta.arg.userId;
      state.userAccessHistories[userId] = PEV({
        data: action.payload.dataSource,
        columns: action.payload.columns,
      });
    },
    [getUserAccessHistory.rejected.type]: (state, action) => {
      let userId = action.meta.arg.userId;
      state.userAccessHistories[userId] = PEV(
        { ...state.userAccessHistories },
        null,
        "Error while fetching userAccessHistory"
      );
    },
  },
});

export const UserApplicationReducer = UserApplicationSlice.reducer;
export const UserApplicationActions = { getUserAccessHistory };
